import React, { createContext, useReducer, useContext, useEffect } from "react";

const initialState = {
  allPrescheduleEquip: [],
  preschedule: {},
  isFinished: false,
};

const DashboardPrescheduleContext = createContext(initialState);

const dashboardPrescheduleReducer = (state, action) => {
  switch (action.type) {
    case "SET_ALL_PRESCHEDULE_DEVOLUTION_EQUIPMENT":
      return {
        ...state,
        allPrescheduleEquip: action.payload,
      };
    case "SET_PRESCHEDULE_DEVOLUTION_EQUIPMENT":
      return {
        ...state,
        preschedule: action.payload,
      };
    case "SET_IS_FINISHED":
      return {
        ...state,
        isFinished: action.payload,
      };
    case "RESET_STATE":
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export const DashboardPrescheduleProvider = ({ children }) => {
  const [state, dispatch] = useReducer(
    dashboardPrescheduleReducer,
    initialState,
    () => {
      const localData = localStorage.getItem("dashboardPrescheduleState");
      return localData ? JSON.parse(localData) : initialState;
    },
  );

  useEffect(() => {
    localStorage.setItem("dashboardPrescheduleState", JSON.stringify(state));
  }, [state]);

  const purgeDashboardPrescheduleState = () => {
    localStorage.removeItem("dashboardPrescheduleState");
    dispatch({ type: "RESET_STATE" });
  };

  return (
    <DashboardPrescheduleContext.Provider
      value={{ state, dispatch, purgeDashboardPrescheduleState }}
    >
      {children}
    </DashboardPrescheduleContext.Provider>
  );
};

export const useDashboardPreschedule = () => {
  const context = useContext(DashboardPrescheduleContext);
  if (!context) {
    throw new Error(
      "useDashboardPreschedule must be used within an DashboardPrescheduleProvider",
    );
  }
  return context;
};
